export const deepCases = [
  {
    id: "dc1",
    kind: "法制咖锤 · 税务",
    title: "顶流男演员阴阳合同全链复盘：从报备到核查的时间线",
    lead:
      "我们汇总了税务部门核查进展与多方信源，把这件事从最初的风声，到报备文件流出，再到补缴金额浮出水面，还原成一条可核验的证据时间线。",
    status: "核查中",
    image:
      "https://readdy.ai/api/search-image?query=wide%20overhead%20view%20of%20a%20warm%20desk%20covered%20in%20tax%20documents%2C%20receipts%2C%20and%20a%20calculator%2C%20editorial%20investigative%20documentary%2C%20muted%20warm%20tones%20with%20crimson%20accents%2C%20soft%20window%20light%2C%20layered%20paper%20texture%2C%20clean%20cinematic%20composition&width=1280&height=720&seq=deepcase-doc-01&orientation=landscape",
    timeline: [
      {
        time: "第 1 阶段 · 风声",
        title: "坊间流传补税传闻",
        text: "多位娱乐营销号在同日密集发布“某顶流面临大额补税”的匿名预告，措辞高度一致，被疑有信源统一放风。",
      },
      {
        time: "第 2 阶段 · 报备流出",
        title: "报备文件与合同截图流传",
        text: "社交平台上出现两版疑似报备文件，对外“打包价”与演员真实收款口径差异明显，引发财税人士逐项比对。",
      },
      {
        time: "第 3 阶段 · 介入",
        title: "税务部门要求限期提交账册",
        text: "据接近稽查人员的人士称，涉事工作室被要求限期提交完整财务账册与银行流水，核查范围覆盖关联工作室与分红安排。",
      },
      {
        time: "第 4 阶段 · 当前",
        title: "金额核算中，静待官方通报",
        text: "补缴本金、滞纳金与罚款数额尚在核算，涉事方回应“全力配合”。我们持续跟进，一有官方通报将第一时间落地实锤。",
      },
    ],
  },
  {
    id: "dc2",
    kind: "合同纠纷 · 解约",
    title: "天价违约金之争：对赌条款谁说了算？",
    lead:
      "一线女星与原公司的解约官司，本质是“业绩承诺”条款的两种读法。我们把双方主张、合同关键条款与业内类似判例摊开，判断谁更可能胜诉。",
    status: "对簿公堂",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20legal%20contract%20document%20with%20signature%20lines%20and%20fountain%20pen%20on%20warm%20wood%2C%20editorial%20documentary%2C%20warm%20amber%20tones%20with%20soft%20crimson%20shadow%2C%20shallow%20depth%20of%20field%2C%20focused%20detail%2C%20cinematic&width=1280&height=720&seq=deepcase-contract-01&orientation=landscape",
    timeline: [
      {
        time: "条款之争 · 商单口径",
        title: "业绩指标如何统计是首轮争议",
        text: "原公司主张按“外部代理签约总额”计业绩，女星方主张仅计算经由公司主导、实际落地的项目，统计口径差距可达数成。",
      },
      {
        time: "履约之争 · 分摊",
        title: "代跑与压价被列为关键证据",
        text: "女星方举证公司曾“代为跑单”以冲量，并存在不合理低价压签，主张业绩未达标系公司经营失误所致，而非其怠于履约。",
      },
      {
        time: "救济之争 · 违约金",
        title: "天价违约金是否畸高成焦点",
        text: "法律人士指出，违约金是否过高需结合实际损失综合裁量，若公司与剧组、品牌存在连环合约，解约连锁损失将成为金额认定的关键变量。",
      },
    ],
  },
];

export const topics = [
  {
    id: "tp1",
    kind: "税务专题",
    title: "税务大潮下的行业众生相：谁在补，谁在藏",
    desc:
      "从头部主播到顶流演员，再到一批中小工作室，税务合规新规落地后，补税、注销、合并工作室的现象集中出现。我们拆解背后三类典型操作，并给出普通人判断“谁在真补、谁在应付”的三个信号。",
    points: [
      "“工作室注销潮”：解释为何密集注销反而需要更彻底地解释历史申报",
      "“佣金拆分术”：灵活用工与坑位费拆分在哪些环节容易被系统标记",
      "三种自查信号：回应措辞、账册期限与是否引入外部审计",
    ],
    image:
      "https://readdy.ai/api/search-image?query=panoramic%20view%20of%20a%20modern%20financial%20office%20with%20rows%20of%20documents%2C%20calculators%20and%20screens%20in%20warm%20golden%20light%2C%20editorial%20documentary%2C%20muted%20amber%20and%20crimson%20grading%2C%20clean%20composition%2C%20cinematic%20depth%2C%20high%20detail&width=1600&height=900&seq=topic-tax-01&orientation=landscape",
    imageAlt: "税务核查主题：散落账本与计算器的现代财务办公室",
  },
  {
    id: "tp2",
    kind: "合同专项",
    title: "解约潮背后：一份份“锁死式”经纪约如何炼成",
    desc:
      "近年来明星与老东家对簿公堂的案例显著增多。合同里的独家排他、业绩对赌、商单分成与“道德条款”，正成为撕破脸时的双刃剑。我们从公开判决里提炼出最容易产生争议的四类条款。",
    points: [
      "独家与排他：违约触发点的边界为何常被模糊处理",
      "业绩对赌：指标写进合同时，统计口径往往才是真正的战场",
      "道德条款：品牌撤代言的主动权如何被合同提前锁定",
      "分手成本：高额违约金在诉讼中如何被法院酌情调整",
    ],
    image:
      "https://readdy.ai/api/search-image?query=panoramic%20editorial%20shot%20of%20a%20legal%20desk%20with%20stacked%20contract%20files%20and%20a%20gavel%20in%20warm%20light%2C%20muted%20amber%20and%20crimson%20tones%2C%20documentary%20mood%2C%20cinematic%20composition%2C%20high%20detail&width=1600&height=900&seq=topic-contract-01&orientation=landscape",
    imageAlt: "合同纠纷主题：堆叠的合约档案与法槌",
  },
];

export const insights = [
  {
    id: "in1",
    num: "01",
    title: "“阴合同”是怎么把价格藏起来的？",
    excerpt:
      "用对外报备的“阳合同”压低税基、以私下约定的“阴合同”锁定真实收入，是税务问题最常见的操作底座。我们拆解资金如何经关联账户周转、为何总在“补税”环节露馅。",
    reads: "88.6万",
  },
  {
    id: "in2",
    num: "02",
    title: "综艺“保量”承诺为什么总对不上账",
    excerpt:
      "从“观看门槛”到“话题KPI”，节目方画的大饼往往包含大量无法被第三方验证的口径。广告主如何识破话术、在合同里锁定可审计的量化指标，是本文要讲清的生存课。",
    reads: "64.2万",
  },
  {
    id: "in3",
    num: "03",
    title: "塌房预告的三板斧，其实是统一的信号源",
    excerpt:
      "塌房前夜，营销号往往同步放出高度一致的匿名预告。我们从信源时差、措辞指纹与粉丝圈联动三个维度，教你判断一次“预告”是否真的有实锤跟进。",
    reads: "112.7万",
  },
  {
    id: "in4",
    num: "04",
    title: "证据链到底怎么算“实锤”？",
    excerpt:
      "截图可伪造、录音可剪辑、数据可注水。我们把“实锤”拆成原始性、唯一性、可核验性与官方佐证四个维度，帮你给正在吃瓜的每一件事打一个靠谱的“可信度分”。",
    reads: "95.3万",
  },
];